//initial redux
import { put, call, takeEvery, fork, all, take, takeLatest, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import pointsservice from "../../../services/points";
import moment from "moment";
import evidenceservice from "../../../services/evidence";
import {types as siteTypes} from "../../../ui/Home/redux";
import { array as arrayUtil } from "../../../utils";

//TODO: Copied from DailyFailureChart, needs to be modified/changed to work with the SEVEN things that need to display on the highchart.
// Top Chart
// 1 column - Verification Rule Failures
// 2 line - Ambient Temperature, Energy Costs/kWh
// 1 plotband - Per-Set Tests
// 3 Icon - Automated Actions, Diagnostic Rules, Implemented Changes

export const chartIndex = {
	energyCostsDollars: 0,
	energyCostsKwh: 1,
	ambientTemperature: 2,
	automatedActions: 3,
	diagnosticRules: 4,
	implementedChanges: 5,
	preSetTests: 6,
	verificationRuleFailures: 7,
	comments: 8,
	learnedRuleChanges: 9, // different chart
}

const initialState = {
	isBusy: false,
	isBusyECD: false,
	isBusyECK: false,
	isBusyAT: false,
	isBusyAA: false,
	isBusyDR: false,
	isBusyIC: false,
	isBusyPST: false,
	isBusyLRC: false,
	isBusyVRF: false,
	isBusyCO: false,

	showEnergyCostsDollars: true,
	showEnergyCostsKwh: false,
	showAmbientTemperature: true,
	showAutomatedActions: true,
	showDiagnosticRules: true,
	showImplementedChanges: true,
	showPreSetTests: true,
	showLearnedRuleChanges: true,
	showVerificationRuleFailures: true,	
	showComments: true,

	currentLoadedSiteName: "",

	ruleInstanceId: null,
	isMouseIn: false,
	mouseX: 0,
	mouseMovedOn: moment(),

	energyCostsDollars: [],
	energyCostsKwh: [],
	ambientTemperatures: [],
	automatedActions: [],
	diagnosticRules: [],
	implementedChanges: [],
	preSetTests: [],
	learnedRuleChanges: [],
	verificiationRuleFailures: [],

	nearestECD: null,
	nearestECK: null, 
	nearestAT: null, 
	nearestAA: null, 
	nearestDR: null, 
	nearestIC: null, 
	nearestPST: null,
	nearestPSTI: null,
	nearestLRC: null, 
	nearestVRF: null,
	nearestCO: null,
};

/////////
//types
export const types = {
	TRY_LOAD_DATA: "components/evidencecomponentchart/TRY_LOAD_DATA",
	TRY_LOAD_DATA_STOPPED: "components/evidencecomponentchart/TRY_LOAD_DATA_STOPPED",
	LOAD_DATA_STARTED: "components/evidencecomponentchart/LOAD_DATA_STARTED",
	ON_LOAD_DATA: "components/evidencecomponentchart/ON_LOAD_DATA",
	ON_LOAD_DATA_FAILED: "components/evidencecomponentchart/ON_LOAD_DATA_FAILED",

	ON_LOAD_ENERGY_COSTS_DOLLARS: "components/evidencecomponentchart/ON_LOAD_ENERGY_COSTS_DOLLARS",
	ON_LOAD_ENERGY_COSTS_DOLLARS_FAILED: "components/evidencecomponentchart/ON_LOAD_ENERGY_COSTS_DOLLARS_FAILED",
	ON_LOAD_ENERGY_COSTS_KWH: "components/evidencecomponentchart/ON_LOAD_ENERGY_COSTS_KWH",
	ON_LOAD_ENERGY_COSTS_KWH_FAILED: "components/evidencecomponentchart/ON_LOAD_ENERGY_COSTS_KWH_FAILED",
	ON_LOAD_AMBIENT_TEMPERATURE: "components/evidencecomponentchart/ON_LOAD_AMBIENT_TEMPERATURE",
	ON_LOAD_AMBIENT_TEMPERATURE_FAILED: "components/evidencecomponentchart/ON_LOAD_AMBIENT_TEMPERATURE_FAILED",
	ON_LOAD_AUTOMATED_ACTIONS: "components/evidencecomponentchart/ON_LOAD_AUTOMATED_ACTIONS",
	ON_LOAD_AUTOMATED_ACTIONS_FAILED: "components/evidencecomponentchart/ON_LOAD_AUTOMATED_ACTIONS",
	ON_LOAD_DIAGNOSTIC_RULES: "components/evidencecomponentchart/ON_LOAD_DIAGNOSTIC_RULES",
	ON_LOAD_DIAGNOSTIC_RULES_FAILED: "components/evidencecomponentchart/ON_LOAD_DIAGNOSTIC_RULES_FAILED",
	ON_LOAD_IMPLEMENTED_CHANGES: "components/evidencecomponentchart/ON_LOAD_IMPLEMENTED_CHANGES",
	ON_LOAD_IMPLEMENTED_CHANGES_FAILED: "components/evidencecomponentchart/ON_LOAD_IMPLEMENTED_CHANGES_FAILED",
	ON_LOAD_PRE_SET_TESTS: "components/evidencecomponentchart/ON_LOAD_PRE_SET_TESTS",
	ON_LOAD_PRE_SET_TESTS_FAILED: "components/evidencecomponentchart/ON_LOAD_PRE_SET_TESTS_FAILED",
	ON_LOAD_LEARNED_RULE_CHANGES: "components/evidencecomponentchart/ON_LOAD_LEARNED_RULE_CHANGES",
	ON_LOAD_LEARNED_RULE_CHANGES_FAILED: "components/evidencecomponentchart/ON_LOAD_LEARNED_RULE_CHANGES_FAILED",
	ON_LOAD_VERIFICATION_RULE_FAILURES: "components/evidencecomponentchart/ON_LOAD_VERIFICATION_RULE_FAILURES",
	ON_LOAD_VERIFICATION_RULE_FAILURES_FAILED: "components/evidencecomponentchart/ON_LOAD_VERIFICATION_RULE_FAILURES_FAILED",
	ON_LOAD_COMMENTS: "components/evidencecomponentchart/ON_LOAD_COMMENTS",
	ON_LOAD_COMMENTS_FAILED: "components/evidencecomponentchart/ON_LOAD_COMMENTS_FAILED",

	TOGGLE_ENERGY_COSTS_DOLLARS: "components/evidencecomponentchart/TOGGLE_ENERGY_COSTS_DOLLARS",
	TOGGLE_ENERGY_COSTS_KWH: "components/evidencecomponentchart/TOGGLE_ENERGY_COSTS_KWH",
	TOGGLE_AMBIENT_TEMPERATURE: "components/evidencecomponentchart/TOGGLE_AMBIENT_TEMPERATURE",
	TOGGLE_AUTOMATED_ACTIONS: "components/evidencecomponentchart/TOGGLE_AUTOMATED_ACTIONS",
	TOGGLE_DIAGNOSTIC_RULES: "components/evidencecomponentchart/TOGGLE_DIAGNOSTIC_RULES",
	TOGGLE_IMPLEMENTED_CHANGES: "components/evidencecomponentchart/TOGGLE_IMPLEMENTED_CHANGES",
	TOGGLE_PRE_SET_TESTS: "components/evidencecomponentchart/TOGGLE_PRE_SET_TESTS",
	TOGGLE_LEARNED_RULE_CHANGES: "components/evidencecomponentchart/TOGGLE_LEARNED_RULE_CHANGES",
	TOGGLE_VERIFICATION_RULE_FAILURES: "components/evidencecomponentchart/TOGGLE_VERIFICATION_RULE_FAILURES",
	TOGGLE_COMMENTS: "components/evidencecomponentchart/TOGGLE_COMMENTS",

	ON_TOGGLE_ENERGY_COSTS_DOLLARS: "components/evidencecomponentchart/ON_TOGGLE_ENERGY_COSTS_DOLLARS",
	ON_TOGGLE_ENERGY_COSTS_KWH: "components/evidencecomponentchart/ON_TOGGLE_ENERGY_COSTS_KWH",
	ON_TOGGLE_AMBIENT_TEMPERATURE: "components/evidencecomponentchart/ON_TOGGLE_AMBIENT_TEMPERATURE",
	ON_TOGGLE_AUTOMATED_ACTIONS: "components/evidencecomponentchart/ON_TOGGLE_AUTOMATED_ACTIONS",
	ON_TOGGLE_DIAGNOSTIC_RULES: "components/evidencecomponentchart/ON_TOGGLE_DIAGNOSTIC_RULES",
	ON_TOGGLE_IMPLEMENTED_CHANGES: "components/evidencecomponentchart/ON_TOGGLE_IMPLEMENTED_CHANGES",
	ON_TOGGLE_PRE_SET_TESTS: "components/evidencecomponentchart/ON_TOGGLE_PRE_SET_TESTS",
	ON_TOGGLE_LEARNED_RULE_CHANGES: "components/evidencecomponentchart/ON_TOGGLE_LEARNED_RULE_CHANGES",
	ON_TOGGLE_VERIFICATION_RULE_FAILURES: "components/evidencecomponentchart/ON_TOGGLE_VERIFICATION_RULE_FAILURES",
	ON_TOGGLE_COMMENTS: "components/evidencecompoentchart/ON_TOGGLE_COMMENTS",

	SET_CURRENT_LOADED_TIME: "components/evidencecomponentchart/SET_CURRENT_LOAD_TIME",
	SET_CURRENT_LOADED_SITENAME: "components/evidencecomponentchart/SET_CURRENT_LOADED_SITENAME",
	SET_CURRENT_LOADED_TARIFF: "components/evidencecomponentchart/SET_CURRENT_LOADED_TARIFF",

	RESET_CURRENT_LOADED: "components/evidencecomponentchart/RESET_CURRENT_LOADED",
	MOUSE_MOVED_IN_CONTAINER: "components/evidencecomponentchart/MOUSE_MOVED_IN_CONTAINER",
	SET_NEAREST_VALUES: "components/evidencecomponentchart/SET_NEAREST_VALUES",

	RESET_TOGGLED: "components/evidencecomponentchart/RESET_TOGGLED",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.LOAD_DATA_STARTED:
				return { ...state, isBusy: true, isBusyCO: true, isBusyECD: true, isBusyECK: true, isBusyAT: true, isBusyAA: true, isBusyDR: true, isBusyIC: true, isBusyPST: true, isBusyLRC: true, isBusyVRF: true };
			case types.LOAD_DATA_FAILED:
				return { ...state, isBusy: false, isBusyCO: false, isBusyECD: false, isBusyECK: false, isBusyAT: false, isBusyAA: false, isBusyDR: false, isBusyIC: false, isBusyPST: false, isBusyLRC: false, isBusyVRF: false };
			case types.TRY_LOAD_DATA:
				return { ...state, navigateFunc: action.payload.navigateFunc};

			case types.ON_LOAD_ENERGY_COSTS_DOLLARS:
				return { ...state, isBusyECD: false, energyCostsDollars: action.payload };
			case types.ON_LOAD_ENERGY_COSTS_KWH:
				return { ...state, isBusyECK: false, energyCostsKwh: action.payload };
			case types.ON_LOAD_AMBIENT_TEMPERATURE:
				return { ...state, isBusyAT: false, ambientTemperatures: action.payload };
			case types.ON_LOAD_AUTOMATED_ACTIONS:
				return { ...state, isBusyAA: false, automatedActions: action.payload };
			case types.ON_LOAD_DIAGNOSTIC_RULES:
				return { ...state, isBusyDR: false, diagnosticRules: action.payload };
			case types.ON_LOAD_IMPLEMENTED_CHANGES:
				return { ...state, isBusyIC: false, implementedChanges: action.payload };
			case types.ON_LOAD_PRE_SET_TESTS:
				return { ...state, isBusyPST: false, preSetTests: action.payload.pst, preSetTestItems: action.payload.psti };
			case types.ON_LOAD_LEARNED_RULE_CHANGES:
				return { ...state, isBusyLRC: false, learnedRuleChanges: action.payload };
			case types.ON_LOAD_VERIFICATION_RULE_FAILURES:
				return { ...state, isBusyVRF: false, verificiationRuleFailures: action.payload };
			case types.ON_LOAD_COMMENTS:
				return { ...state, isBusyCO: false, comments: action.payload };

			case types.ON_LOAD_ENERGY_COSTS_DOLLARS_FAILED:
				return { ...state, isBusyECD: false };
			case types.ON_LOAD_ENERGY_COSTS_KWH_FAILED:
				return { ...state, isBusyECK: false };
			case types.ON_LOAD_AMBIENT_TEMPERATURE_FAILED:
				return { ...state, isBusyAT: false };
			case types.ON_LOAD_AUTOMATED_ACTIONS_FAILED:
				return { ...state, isBusyAA: false };
			case types.ON_LOAD_DIAGNOSTIC_RULES_FAILED:
				return { ...state, isBusyDR: false };
			case types.ON_LOAD_IMPLEMENTED_CHANGES_FAILED:
				return { ...state, isBusyIC: false };
			case types.ON_LOAD_PRE_SET_TESTS_FAILED:
				return { ...state, isBusyPST: false };
			case types.ON_LOAD_LEARNED_RULE_CHANGES_FAILED:
				return { ...state, isBusyLRC: false };
			case types.ON_LOAD_VERIFICATION_RULE_FAILURES_FAILED:
				return { ...state, isBusyVRF: false };
			case types.ON_LOAD_COMMENTS_FAILED:
				return { ...state, isBusyCO: false };
			
			case types.ON_TOGGLE_ENERGY_COSTS_DOLLARS:
				return { ...state, showEnergyCostsDollars: action.payload.val };
			case types.ON_TOGGLE_ENERGY_COSTS_KWH:
				return { ...state, showEnergyCostsKwh: action.payload.val };
			case types.ON_TOGGLE_AMBIENT_TEMPERATURE:
				return { ...state, showAmbientTemperature: action.payload.val };
			case types.ON_TOGGLE_AUTOMATED_ACTIONS:
				return { ...state, showAutomatedActions: action.payload.val };
			case types.ON_TOGGLE_DIAGNOSTIC_RULES:
				return { ...state, showDiagnosticRules: action.payload.val };
			case types.ON_TOGGLE_IMPLEMENTED_CHANGES:
				return { ...state, showImplementedChanges: action.payload.val };
			case types.ON_TOGGLE_PRE_SET_TESTS:
				return { ...state, showPreSetTests: action.payload.val };
			case types.ON_TOGGLE_LEARNED_RULE_CHANGES:
				return { ...state, showLearnedRuleChanges: action.payload.val };
			case types.ON_TOGGLE_VERIFICATION_RULE_FAILURES:
				return { ...state, showVerificationRuleFailures: action.payload.val };
			case types.ON_TOGGLE_COMMENTS:
				return { ...state, showComments: action.payload.val };

			case types.SET_CURRENT_LOADED_TIME:
				return { ...state, currentLoadedTime: action.payload }
			case types.SET_CURRENT_LOADED_SITENAME:
				return { ...state, currentLoadedSiteName: action.payload }
			case types.SET_CURRENT_LOADED_TARIFF:
				return { ...state, currentLoadedTariff: action.payload }

			case types.SET_RULE_INSTANCE_ID:
				return { ...state, ruleInstanceId: action.payload }

			case types.ON_LOAD_DATA:
				return { ...state, isBusy: false };
			case types.ON_LOAD_DATA_FAILED:
				return { ...state, errors: action.payload }
			case types.RESET_CURRENT_LOADED:
				return { ...state, currentLoadedTime: null, currentLoadedSiteName: null, currentLoadedTariff: undefined}
			case types.MOUSE_MOVED_IN_CONTAINER:
				return { ...state, isMouseIn: action.payload.isIn, mouseX: action.payload.x, mouseMovedOn: action.payload.now };

			case types.SET_NEAREST_VALUES:
				return { ...state, 
					nearestECD: action.payload.nECD,
					nearestECK: action.payload.nECK, 
					nearestAT: action.payload.nAT, 
					nearestAA: action.payload.nAA, 
					nearestDR: action.payload.nDR, 
					nearestIC: action.payload.nIC, 
					nearestPST: action.payload.nPST,
					nearestPSTI: action.payload.nPSTI,
					nearestLRC: action.payload.nLRC, 
					nearestVRF: action.payload.nVRF,
					nearestCO: action.payload.nCO,
				}
			case types.RESET_TOGGLED:
				return { ...state,
					showEnergyCostsDollars: true,
					showEnergyCostsKwh: false,
					showAmbientTemperature: true,
					showAutomatedActions: true,
					showDiagnosticRules: true,
					showImplementedChanges: true,
					showPreSetTests: true,
					showLearnedRuleChanges: true,
					showVerificationRuleFailures: true,	
					showComments: true
				}
			default:
				return state;
		}
	}
};

const ecdSeries = {
	type: 'line',
	data: [],
	name: 'Energy Cost (dollars)',
	yAxis: chartIndex.energyCostsDollars,
	color: '#6fb8c9',
	lineWidth: 2,
	marker: {
		enabled: false,
	},
	zIndex: 30,
};

const eckSeries = {
	type: 'line',
	data: [],
	name: 'Energy Cost (kWh)',
	yAxis: chartIndex.energyCostsKwh,
	color: '#6fb8c9',
	lineWidth: 2,
	marker: {
		enabled: false,
	},
	zIndex: 30,
};

const atSeries = {
	type: 'line',
	data: [],
	name: 'Ambient Temperature (C)',
	yAxis: chartIndex.ambientTemperature,
	color: '#3c9946',
	lineWidth: 2,
	marker: {
		enabled: false,
	},
	zIndex: 20,
};

const aaSeries = {
	data: [],
	name: 'Automated Action',
	yAxis: chartIndex.automatedActions,
	lineWidth: 0,
	min: 0,
	max: 1,
	color: '#E83B3A',
	states: {
		hover: {
			lineWidth: 0,
			lineWidthPlus: 0,
		}
	},
	marker: {
		enabled: true,
		height: 30,
		width: 30,
		symbol: 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNjAgNjAiPiAgICA8cGF0aCBkPSJNMTUsMjYgTDMwLDYwIEw0NSwyNiIgZmlsbD0iI0U4M0IzQSIgLz4gICAgPGNpcmNsZSBjeD0iMzAiIGN5PSIyNiIgcj0iMjUiIGZpbGw9IiNFODNCM0EiIC8+PC9zdmc+)',
	},
	zIndex: 90,
};

const drSeries = {
	data: [],
	name: 'Diagnostic Rule',
	yAxis: chartIndex.diagnosticRules,
	lineWidth: 0,
	min: 0,
	max: 1,
	color: '#0F2547',
	states: {
		hover: {
			lineWidth: 0,
			lineWidthPlus: 0,
		}
	},
	marker: {
		enabled: true,
		height: 30,
		width: 30,
		symbol: 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNjAgNjAiPiAgICA8Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIyOCIgc3Ryb2tlPSIjMEYyNTQ3IiBzdHJva2Utd2lkdGg9IjQiIGZpbGw9IiNGRkZGRkYiIC8+XCAgICA8cmVjdCB4PSIxMyIgeT0iMzIiIHdpZHRoPSI0IiBoZWlnaHQ9IjEyIiBmaWxsPSIjMEYyNTQ3IiAvPiAgICA8cmVjdCB4PSIyMyIgeT0iMjEiIHdpZHRoPSI0IiBoZWlnaHQ9IjIzIiBmaWxsPSIjMEYyNTQ3IiAvPiAgICA8cmVjdCB4PSIzMyIgeT0iMTEiIHdpZHRoPSI0IiBoZWlnaHQ9IjMzIiBmaWxsPSIjMEYyNTQ3IiAvPiAgICA8cmVjdCB4PSI0MyIgeT0iMzMiIHdpZHRoPSI0IiBoZWlnaHQ9IjExIiBmaWxsPSIjMEYyNTQ3IiAvPjwvc3ZnPg==)'
	},
	zIndex: 90,
};

const icSeries = {
	data: [],
	name: 'Implemented Change',
	yAxis: chartIndex.implementedChanges,
	lineWidth: 0,
	min: 0,
	max: 1,
	color: '#FCB828',
	states: {
		hover: {
			lineWidth: 0,
			lineWidthPlus: 0,
		}
	},
	marker: {
		enabled: true,
		height: 30,
		width: 30,
		symbol: 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNjAgNjAiPiAgICA8cGF0aCBkPSJNMTUsMjYgTDMwLDYwIEw0NSwyNiIgZmlsbD0iI0ZDQjgyOCIgLz4gICAgPGNpcmNsZSBjeD0iMzAiIGN5PSIyNiIgcj0iMjUiIGZpbGw9IiNGQ0I4MjgiIC8+PC9zdmc+)'
	},
	zIndex: 90,
};

const coSeries = {
	type: 'line',
	data: [],
	name: 'Comment',
	yAxis: chartIndex.comments,
	lineWidth: 0,
	min: 0,
	max: 1,
	color: '#7B52A6',
	states: {
		hover: {
			lineWidth: 0,
			lineWidthPlus: 0,
		}
	},
	marker: {
		enabled: true,
		height: 30,
		width: 30,
		symbol: 'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNjAgNjAiPiAgICAgPGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMjUiIGZpbGw9IiM3QjUyQTYiIC8+ICAgIDxwYXRoIGQ9Ik0yMCwyMCBMNDAsMjAgTDQwLDMwIEwzMCwzMCBMMzAsNDAgTDIwLDQwIEwyMCwyMCIgZmlsbD0iI0ZGRiIgLz4gICAgPHBhdGggZD0iTTMwLDMwIEw0MCwzMCBMMzAsNDAgTDMwLDMwIiBmaWxsPSIjQzY5QUY0IiAvPjwvc3ZnPg==)'
	},
	zIndex: 90,
};

const pstSeries = {
	data: [],
	name: 'Pre-Set Test',
	yAxis: chartIndex.preSetTests,
	zIndex: 0,
};

const lrcSeries = {
	type: 'line',
	data: [],
	name: 'Learned Rule Change',
	yAxis: chartIndex.learnedRuleChanges,
	color: '#536bad',
	lineWidth: 2,
	marker: {
		enabled: false,
	},
	zIndex: 40,
};

const vrfSeries = {
	type: 'column',
	data: [],
	name: 'Verification Rule Failure (failcount)',
	yAxis: chartIndex.verificationRuleFailures,
	color: '#E83B3A',
	zIndex: 10,
};

function setupChart(topChart, fromDate, toDate) {
	if(!topChart){return false;}

	let adjustedToDate = moment(toDate);
	adjustedToDate.add(1, 'seconds');

	var start = moment(fromDate).utc().add(moment(fromDate).utcOffset(), 'm').valueOf();
	var end = moment(adjustedToDate).utc().add(moment(fromDate).utcOffset(), 'm').valueOf();

	topChart.xAxis[0].setExtremes(start, end);
	
	topChart.xAxis[0].removePlotBand("preSetTest");

	if(topChart.series.length === 0) {
		topChart.addSeries(ecdSeries);
		topChart.addSeries(eckSeries);
		topChart.addSeries(atSeries);
		topChart.addSeries(aaSeries);
		topChart.addSeries(drSeries);
		topChart.addSeries(icSeries);
		topChart.addSeries(pstSeries);
		topChart.addSeries(vrfSeries);
		topChart.addSeries(coSeries);
		topChart.addSeries(lrcSeries);
	} else {
		topChart.series[chartIndex.energyCostsDollars].update(ecdSeries, true);
		topChart.series[chartIndex.energyCostsKwh].update(eckSeries, true);
		topChart.series[chartIndex.ambientTemperature].update(atSeries, true);
		topChart.series[chartIndex.automatedActions].update(aaSeries, true);
		topChart.series[chartIndex.diagnosticRules].update(drSeries, true);
		topChart.series[chartIndex.implementedChanges].update(icSeries, true);
		topChart.series[chartIndex.preSetTests].update(pstSeries, true);
		topChart.series[chartIndex.verificationRuleFailures].update(vrfSeries, true);
		topChart.series[chartIndex.comments].update(coSeries, true);
		topChart.series[chartIndex.learnedRuleChanges].update(lrcSeries, true);
	}

	return true;
}

function addEnergyCostsDollarsToChart(chart, energyCostsDollars) {
	if(!chart || !chart.series || !energyCostsDollars || !energyCostsDollars.length) {
		return;
	}
	let newEcdSeries = { ...ecdSeries, data: [] };

	energyCostsDollars.forEach(ecd => {
		if(ecd.timestamp) {
			var date = moment(ecd.timestamp).utc().add(moment(ecd.timestamp).utcOffset(), 'm').valueOf();
			newEcdSeries.data.push({x: date, y: ecd.value});
		}
	});

	chart.series[chartIndex.energyCostsDollars].update(newEcdSeries, false);

	return newEcdSeries.data;
}

function addEnergyCostsKwhToChart(chart, energyCostsKwh) {
	if(!chart || !chart.series || !energyCostsKwh || !energyCostsKwh.length) {
		return;
	}
	let newEckSeries = { ...eckSeries, data: [] };

	energyCostsKwh.forEach(eck => {
		if(eck.timestamp) {
			var date = moment(eck.timestamp).utc().add(moment(eck.timestamp).utcOffset(), 'm').valueOf();
			newEckSeries.data.push({x: date, y: eck.value});
		}
	});

	chart.series[chartIndex.energyCostsKwh].update(newEckSeries, false);

	return newEckSeries.data;
}

function addAmbientTemperatureToChart(chart, ambientTemperatures) {
	if(!chart || !chart.series || !ambientTemperatures || !ambientTemperatures.length) {
		return;
	}
	let newAtSeries = { ...atSeries, data: [] };

	ambientTemperatures.forEach(at => {
		if(at.timestamp) {
			var date = moment(at.timestamp).utc().add(moment(at.timestamp).utcOffset(), 'm').valueOf();
			newAtSeries.data.push({x: date, y: at.value});
		}
	});

	chart.series[chartIndex.ambientTemperature].update(newAtSeries, false);

	return newAtSeries.data;
}

function addAutomatedActionsToChart(chart, automatedActions) {
	if(!chart || !chart.series || !automatedActions || !automatedActions.length) {
		return;
	}
	let newAaSeries = { ...aaSeries, data: [] };

	let mixedData = [];
	for(var ii = 0; ii < automatedActions.length; ii++) {
		let aa = automatedActions[ii];
		if(aa.implementedOn) {
			if(mixedData.length === 0) {
				mixedData.push(aa);
			} else {
				if(moment(mixedData[0].date).utc().valueOf() === moment(aa.date).utc().valueOf()) {
					mixedData.push(aa);
				} else {
					let newData = [...mixedData];
					let date = moment(newData[0].date).utc().valueOf();
					newAaSeries.data.push({x: date, y: newData[0].value, data: newData});

					mixedData = [];
					mixedData.push(aa);
				}
			}
		}
	}

	if(mixedData && mixedData.length > 0) {
		let newData = [...mixedData];
		let date = moment(newData[0].date).utc().valueOf();
		newAaSeries.data.push({x: date, y: moment[0].value, data: newData});
	}

	chart.series[chartIndex.automatedActions].update(newAaSeries, false);

	return newAaSeries.data;
}

function addDiagnosticRulesToChart(chart, diagnosticRules, navigateFunc) {
	if(!chart || !chart.series || !diagnosticRules || !diagnosticRules.length) {
		return;
	}
	let newDrSeries = { ...drSeries, 
		data: [],
		point: {
			events: {
				click: function(e) {
					navigateFunc(
						"/Reports/" +  e.point.data[0].ruleInstanceId, {
						time: {
								  startDate: new Date(moment(e.point.data[0].dayStartSiteLocal).startOf("day").valueOf()),
								  key: "selection",
								  endDate: new Date(moment(e.point.data[0].dayStartSiteLocal).endOf("day").valueOf()),
						}});
				}
			}
		}
	};

	let mixedData = [];
	for(var ii = 0; ii < diagnosticRules.length; ii++) {
		let dr = diagnosticRules[ii];
		if(dr.dayStartSiteLocal) {
			if(mixedData.length === 0) {
				mixedData.push(dr);
			} else {
				if(mixedData[0].dayStartSiteLocal.valueOf() === dr.dayStartSiteLocal.valueOf()) {
					mixedData.push(dr);
				} else {
					let newData = [...mixedData];
					let date = moment(newData[0].dayStartSiteLocal).valueOf();
					newDrSeries.data.push({x: date, y: 0.7, data: newData});

					mixedData = [];
					mixedData.push(dr);
				}
			}
		}
	}

	if(mixedData && mixedData.length > 0) {
		let newData = [...mixedData];
		let date = moment(newData[0].dayStartSiteLocal).valueOf();
		newDrSeries.data.push({x: date, y: 0.7, data: newData});
	}

	chart.series[chartIndex.diagnosticRules].update(newDrSeries, false);

	return newDrSeries.data;
}

function addImplementedToChart(chart, implementedChanges, navigateFunc, openImplementedChangeListModalFunc) {
	if(!chart || !chart.series || !implementedChanges || !implementedChanges.length) {
		return;
	}
	let newIcSeries = { 
		...icSeries, 
		data: [],
		point: {
			events: {
				click: function(e) {
					if(e.point.data && e.point.data.length === 1) {
						navigateFunc("/Evidence/Report/" + e.point.data[0].siteName + "/" + (e.point.data[0].iEnergyViewId !== undefined && e.point.data[0].iEnergyViewId !== null ? e.point.data[0].iEnergyViewId : "null") + "/ImplementedChange/" + e.point.data[0].implementedChangeId);
					} else if(e.point.data && e.point.data.length > 1) {
						openImplementedChangeListModalFunc(e.point.data);
					}
				}
			}
		}
	};
	
	let mixedData = [];
	for(var ii = 0; ii < implementedChanges.length; ii++) {
		let ic = implementedChanges[ii];
		if(ic.implementedOn) {
			if(mixedData.length === 0) {
				mixedData.push(ic);
			} else {
				if(mixedData[0].implementedOn.valueOf() === ic.implementedOn.valueOf()) {
					mixedData.push(ic);
				} else {
					let newData = [...mixedData];
					let date = moment(newData[0].implementedOn).valueOf();
					newIcSeries.data.push({x: date, y: 0.9, data: newData});

					mixedData = [];
					mixedData.push(ic);
				}
			}
		}
	}

	if(mixedData && mixedData.length > 0) {
		let newData = [...mixedData];
		let date = moment(newData[0].implementedOn).valueOf();
		newIcSeries.data.push({x: date, y: 0.9, data: newData});
	}

	chart.series[chartIndex.implementedChanges].update(newIcSeries, false);

	return newIcSeries.data;
}

function addPreSetTestsToChart(chart, preSetTests, navigateFunc, show) {
	if(!chart || !chart.xAxis || !chart.xAxis[0] || !preSetTests || !preSetTests.length) {
		return;
	}

	chart.xAxis[0].plotLinesAndBands = [];

	let array = [];

	preSetTests.forEach(pst => {
		pst.preSetTestItems.forEach((psti, index) => {
			let fromDate = moment(psti.fromDate).valueOf();
			let toDate = moment(psti.toDate).valueOf();

			chart.xAxis[0].addPlotBand({
				id: "preSetTest",
				color: "#D6EBEF",
				from: fromDate,
				to: toDate,
				events: {
					click: function(e) {
						if(pst.iEnergyViewId) {
							navigateFunc("/Evidence/Report/" + pst.siteName + "/" + pst.iEnergyViewId + "/PreSetTest/" + pst.preSetTestId);
						} else {
							navigateFunc("/Evidence/Report/" + pst.siteName + "/null/PreSetTest/" + pst.preSetTestId);
						}
					}
				}
			});

			array.push({
				x: ((fromDate + toDate) / 2),
				fromDate: fromDate,
				toDate: toDate,
				preSetTestId: pst.preSetTestId,
				description: pst.description,
				preSetTestItems: pst.preSetTestItems,
				index: index,
				siteName: pst.siteName,
			})
		});
				  
		// hide/show based on toggle status
		if(chart && chart.xAxis[0] && chart.xAxis[0].plotLinesAndBands[0] && chart.xAxis[0].plotLinesAndBands[0].svgElem) {
			if(show) {
				chart.xAxis[0].plotLinesAndBands.forEach(plotBand => {
					if(plotBand.id === "preSetTest") {
						plotBand.svgElem.show();
					}
				});
			} else {
				chart.xAxis[0].plotLinesAndBands.forEach(plotBand => {
					if(plotBand.id === "preSetTest") {
						plotBand.svgElem.hide();
					}
				});
			}
		}
	});

	return array;
}

function addMissingHours(learnedRuleChanges, fromDate, toDate) {
	let data = [];
	let actingDate = new Date(fromDate);
	const actingToDate = new Date(toDate);
	while(actingDate < actingToDate) {
		let year = actingDate.getFullYear();
		let month = actingDate.getMonth() + 1;
		let day = actingDate.getDate();
		let hour = actingDate.getHours();

		let found = learnedRuleChanges.find(x => x.year === year && x.month === month && x.day === day && x.hour === hour);
		var date = moment({year: year, month: month - 1, day: day, hours: hour}).utc().add(moment({year: year, month: month, day: day, hours: hour}).utcOffset(), 'm').valueOf();

		if(found) {
			data.push({x: date, y: found.count})
		} else {
			data.push({x: date, y: 0});
		}

		actingDate.setHours(actingDate.getHours()+1);
	}

	return data;
}

function addLearnedRuleChangesToChart(chart, learnedRuleChanges, fromDate, toDate) {
	if(!chart || !chart.series || !learnedRuleChanges || !learnedRuleChanges.length) {
		return;
	}
	let newLrcSeries = { ...lrcSeries, data: addMissingHours(learnedRuleChanges, fromDate, toDate) };

	chart.series[chartIndex.learnedRuleChanges].update(newLrcSeries, false);

	return newLrcSeries.data;
}

function addVerificationToChart(chart, verificationRuleFailures) {
	if(!chart || !chart.series || !verificationRuleFailures || !verificationRuleFailures.length) {
		return;
	}
	
	let newVrfSeries = { ...vrfSeries, data: [] };

    verificationRuleFailures.forEach(vrf => {
		if(vrf.dayStartSiteLocal) {
			var date = moment(vrf.dayStartSiteLocal).valueOf();
			newVrfSeries.data.push({x: date, y: vrf.failCount});
		}
	});

	chart.series[chartIndex.verificationRuleFailures].update(newVrfSeries, false);

	return newVrfSeries.data;
}

function addCommentsToChart(chart, comments) {
	if(!chart || !chart.series || !comments || !comments.length) {
		return;
	}
	let newCoSeries = { ...coSeries, data: [] };
	
	let mixedData = [];
	for(var ii = 0; ii < comments.length; ii++) {
		let co = comments[ii];
		if(co.implementedOn) {
			if(mixedData.length === 0) {
				mixedData.push(co);
			} else {
				if(mixedData[0].implementedOn.valueOf() === co.implementedOn.valueOf()) {
					mixedData.push(co);
				} else {
					let newData = [...mixedData];
					let date = moment(newData[0].implementedOn).valueOf();
					newCoSeries.data.push({x: date, y: 0.7, data: newData});

					mixedData = [];
					mixedData.push(co);
				}
			}
		}
	}

	if(mixedData && mixedData.length > 0) {
		let newData = [...mixedData];
		let date = moment(newData[0].implementedOn).valueOf();
		newCoSeries.data.push({x: date, y: 0.7, data: newData});
	}

	chart.series[chartIndex.comments].update(newCoSeries, false);

	return newCoSeries.data;
}

function convertDateToUTC(date) {
	return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}

function getView(flattenedSiteTree, rootView, paths){
	let result = null;

	let wkView = rootView;
	if(flattenedSiteTree && rootView && paths && paths.length && flattenedSiteTree.Roots.length){
		for(var ii = 0; ii < paths.length; ii++){
			let wkPath = paths[ii];
         let nextView = null;
         
         const childs = flattenedSiteTree.GetChildrenFor(wkView);

         for (let index = 0; index < childs.length; index++) {
            const childView = childs[index];
            if(childView.name === wkPath){
               nextView = childView;
               break;
            }
         }

			if(!nextView){
				break;
			}else{
				wkView = nextView;
			}
			if(ii === paths.length - 1){
				result = wkView;
			}
		}
	}

	return result;
}

function sortCosts(hourlyCosts){
	let sorted = [];

	//if nothing then nope
	if(!hourlyCosts){
		return sorted;
	}

	for(var something in hourlyCosts) {
		if(hourlyCosts.hasOwnProperty(something)) {
			hourlyCosts[something].forEach(s => {
				sorted.push({
					timestamp: moment(s.timestamp).valueOf(),
					value: s.value,
					period: something
				});
			});
		}
	}
	/*
	//grab the 3 periods
	const offPeak = hourlyCosts["OffPeak"];
	const peak = hourlyCosts["Peak"];
	const shoulder = hourlyCosts["Shoulder"];

	//loop over all periods and add to same array while castign timestamps to moment objects and adding the period as a prop.
	if(offPeak && offPeak.length){
		offPeak.forEach(s => {
			sorted.push({
				timestamp: moment(s.timestamp).valueOf(),
				value: s.value,
				period: "offPeak",
			});
		});
	}

	if(peak && peak.length){
		peak.forEach(s => {
			sorted.push({
				timestamp: moment(s.timestamp).valueOf(),
				value: s.value,
				period: "peak",
			});
		});
	}

	if(shoulder && shoulder.length){
		shoulder.forEach(s => {
			sorted.push({
				timestamp: moment(s.timestamp).valueOf(),
				value: s.value,
				period: "shoulder",
			});
		});
	}
*/
	//now sort the array
	sorted.sort(function(a, b){
		if(a.timestamp > b.timestamp){
			return 1;
		}else if (a.timestamp < b.timestamp){
			return -1;
		}else{
			return a.value - b.value;
		}
	});

	//finally, for some dumbass reason the api call returns the first hour for every period, even if it's not relevent,
	//i.e if time period requests is form 8am-10am, the peak, off-peak, and shoulder will all have values for 8am even though only 1 period should.
	//so now we need to go through and remove teh shitty entries.
	let removalCount = 0;
	for(var ii = 0; ii < sorted.length; ii++){
		//teh dodgy values should always be at start of array with value of zero.
		//Propblem is 0 is a legit value so cant just remove all 0, need to also check the datetime to make sure it's a dupe
		if(sorted[ii].value === 0
			 && ii < sorted.length - 1
			 && sorted[ii].timestamp.valueOf() === sorted[ii + 1].timestamp.valueOf()){
			removalCount++;
		}else{
			//shitty values are at start so no ned to loop through all valeus once we find a good value
			break;
		}
	}

	sorted.splice(0, removalCount);

	return sorted;
}

function splitPST(pst) {
	if(!pst) {
		return [];
	}

	let split = [];
	for(var ii = 0; ii < pst.length; ii++) {
		for(var jj = 0; jj < pst[ii].preSetTestItems.length; jj++) {
			split.push({...pst[ii].preSetTestItems[jj], x: pst[ii].preSetTestItems[jj].fromDate.valueOf()});
		}
	}

	split.sort(function(a, b){
		if(a.fromDate > b.fromDate) {
			return 1;
		} else if (a.fromDate < b.fromDate) {
			return -1;
		} else {
			return 0;
		}
	});

	return split;
}

function sortPSTData(pst) {
	if(!pst) {
		return [];
	}

	pst.sort(function(a, b){
		if(a.fromDate > b.fromDate) {
			return 1;
		} else if (a.fromDate < b.fromDate) {
			return -1;
		} else {
			return 0;
		}
	});
}

function sortVerificationRuleFailures(vrf){
	//if nothing then nope
	if(!vrf){
		return [];
	}

	//now sort the array
	vrf.sort(function(a, b){
		if(a.dayStartSiteLocal > b.dayStartSiteLocal){
			return 1;
		}else if (a.dayStartSiteLocal < b.dayStartSiteLocal){
			return -1;
		}else{
			return a.failCount - b.failCount;
		}
	});

	let groups = vrf.reduce((groups, v) => {
		const date = moment(v.dayStartSiteLocal).utc().valueOf();
		if(!groups[date]) {
			groups[date] = {dayStartSiteLocal: date, failCount: 0};
		}
		groups[date].failCount += v.failCount;
		return groups;
	}, {});

	let sorted = [];
	for (var p in groups) {
		if (groups.hasOwnProperty(p)) {
			sorted.push(groups[p]);
		}
	}

	return sorted;
}

function applyAutomatedActions(automatedActions, verificationRuleFailures) {
	if(!automatedActions && !verificationRuleFailures) {
		return [];
	}
	var max = 1;
	if(verificationRuleFailures) {
		max = verificationRuleFailures.reduce((a, b) => {
			return b.failCount > a.failCount ? b : a;
		}, 0);
	}
	if(max.failCount) {
		max = max.failCount;
	}
	
    var grouped = arrayUtil.groupBy(automatedActions, x => moment(x.siteLocalTime).utc().startOf('day').format());

	var array = [];
	for(var property in grouped) {
		if(grouped.hasOwnProperty(property)) {
			var date = moment(property).valueOf();
			var vrfAt = verificationRuleFailures.find(x => moment(x.dayStartSiteLocal).valueOf() === date);
			if(!vrfAt) {
				array.push({date: date, value: 0.3, data: grouped[property]});
			} else {
				var perc = (vrfAt.failCount / max);
				array.push({date: date, value: (perc - (0.07 * perc)), data: grouped[property]});
			}
		}
	}

	return array;
}

function binarySearch(d, t, s, e) {
	const m = Math.floor((s + e) / 2);
	if(t === d[m].x) return d[m];
	if(e - 1 === s || s === e) {
		if(Math.abs(d[s].x - t) > Math.abs(d[e].x - t)) {
			return d[e]
		} else {
			return d[s];
		} 
	}
	if(t > d[m].x) return binarySearch(d, t, m, e);
	if(t < d[m].x) return binarySearch(d, t, s, m);
}

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([
			this.onLoadData(),
			this.onToggleEnergyCostsDollars(),
			this.onToggleEnergyCostsKwh(),
			this.onToggleAmbientTemperature(),
			this.onToggleAutomatedActions(),
			this.onToggleDiagnosticRules(),
			this.onToggleImplementedChanges(),
			this.onTogglePreSetTests(),
			this.onToggleLearnedRuleChanges(),
			this.onToggleVerificationRuleFailures(),
			this.onToggleComments(),
			this.onMouseMovedInContainer(),
		]);
	},

	*onMouseMovedInContainer() {
		yield takeLatest(types.MOUSE_MOVED_IN_CONTAINER, function*({payload}) {

			yield delay(10);

			const evidenceComponentChart = yield select(x => x.evidenceComponentChart);

			const { 
				isMouseIn,
				mouseX, 
				energyCostsDollars,
				energyCostsKwh,
				ambientTemperatures,
				//automatedActions,
				diagnosticRules,
				implementedChanges,
				preSetTests,
				preSetTestItems,
				learnedRuleChanges,
				verificiationRuleFailures,
				comments } = evidenceComponentChart;

			const mouseLowerX = mouseX - 36000000;
			const mouseUpperX = mouseX + 36000000;

			if(isMouseIn) {
				let nECD = null;
				let nECK = null;
				let nAT = null;
				let nAA = null;
				let nDR = null;
				let nIC = null;
				let nPST = null;
				let nPSTI = null;
				let nLRC = null;
				let nVRF = null;
				let nCO = null;

				if(energyCostsDollars && energyCostsDollars.length) {
					nECD = binarySearch(energyCostsDollars, mouseX, 0, energyCostsDollars.length - 1);
				}
				if(energyCostsKwh && energyCostsKwh.length) {
					nECK = binarySearch(energyCostsKwh, mouseX, 0, energyCostsKwh.length - 1);
				}
				if(ambientTemperatures && ambientTemperatures.length) {
					nAT = binarySearch(ambientTemperatures, mouseX, 0, ambientTemperatures.length - 1);
				}
				/*
				if(automatedActions && automatedActions.length) {
					let bsAA = binarySearch(automatedActions, mouseX, 0, automatedActions.length - 1);
					if(bsAA.x > mouseLowerX && bsAA.x < mouseUpperX) {
						nAA = bsAA;
					}
				}
				*/
				if(diagnosticRules && diagnosticRules.length) {
					let bsDR = binarySearch(diagnosticRules, mouseX, 0, diagnosticRules.length - 1);
					if(bsDR.x > mouseLowerX && bsDR.x < mouseUpperX) {
						nDR = bsDR;
					}
				}
				if(implementedChanges && implementedChanges.length) {
					let bsIC = binarySearch(implementedChanges, mouseX, 0, implementedChanges.length - 1);
					if(bsIC.x > mouseLowerX && bsIC.x < mouseUpperX) {
						nIC = bsIC;
					}
				}
				/*
				if(preSetTests && preSetTests.length) {
					let bsPST = binarySearch(preSetTests, mouseX, 0, preSetTests.length - 1);
					if(bsPST.fromDate < mouseX && mouseX < bsPST.toDate) {
						nPST = bsPST;
					}
				}
				*/
				if(preSetTestItems && preSetTestItems.length) {
					let bsPST = binarySearch(preSetTestItems, mouseX, 0, preSetTestItems.length - 1);
					if(bsPST.fromDate.valueOf() < mouseX && mouseX < bsPST.toDate.valueOf()) {
						let found = preSetTests.find(p => p.preSetTestId === bsPST.preSetTestId)
						nPST = found;
						nPSTI = bsPST;
					}
				}
				if(learnedRuleChanges && learnedRuleChanges.length) {
					nLRC = binarySearch(learnedRuleChanges, mouseX, 0, learnedRuleChanges.length - 1);
				}
				if(verificiationRuleFailures && verificiationRuleFailures.length) {
					nVRF = binarySearch(verificiationRuleFailures, mouseX, 0, verificiationRuleFailures.length - 1);
				}
				if(comments && comments.length) {
					let bsCO = binarySearch(comments, mouseX, 0, comments.length - 1);
					if(bsCO.x > mouseLowerX && bsCO.x < mouseUpperX) {
						nCO = bsCO;
					}
				}

				yield put(actions.setNearestValues({nECD, nECK, nAT, nAA, nDR, nIC, nPST, nPSTI, nLRC, nVRF, nCO}));
			}
		});
	},
	
	*onLoadData(){
		yield takeEvery(types.TRY_LOAD_DATA, function*({payload}){
			const evidenceComponentChart = yield select(x => x.evidenceComponentChart);
			const sitetree = yield select(x => x.sitetree);
			const tariff = yield select(x => x.tariffs);
			if(evidenceComponentChart.currentLoadedSiteName && 
				sitetree.currentSite && 
				evidenceComponentChart.currentLoadedSiteName === sitetree.currentSite.name && 
				evidenceComponentChart.currentLoadedTime && 
				payload.time.startDate === evidenceComponentChart.currentLoadedTime.startDate && 
				payload.time.endDate === evidenceComponentChart.currentLoadedTime.endDate &&
				(tariff.currentTariff && tariff.currentTariff.tariffPK && evidenceComponentChart.currentLoadedTariff === tariff.currentTariff.tariffPK)
				) {
				yield put(actions.loadDataStopped());
				return;
			}

			const siteName = sitetree.currentSite ? sitetree.currentSite.name : null;
			const fromDate = payload.time.startDate;
			const toDate = payload.time.endDate;
			const ruleInstanceId = evidenceComponentChart.ruleInstanceId;

			let ambDegCData = null;

			if(!siteName || !fromDate || !toDate) {
				yield put(actions.onLoadDataFailed("siteName: " + (siteName ? "yes" : "no") + ", fromDate: " + (fromDate ? "yes" : "no") + ", toDate: " + (toDate ? "yes" : "no") + "."));
				return;
			}
			
			var chartHasSetup = setupChart(payload.topChart, fromDate, toDate);
			if(chartHasSetup === false) {
				return;
			}

			yield put(actions.loadDataStarted());

			yield put(actions.setCurrentLoadedTime(payload.time));
			yield put(actions.setCurrentLoadedSiteName(sitetree.currentSite.name));
			if(tariff.currentTariff && tariff.currentTariff.tariffPK) {
				yield put(actions.setCurrentLoadedTariff(tariff.currentTariff.tariffPK));
			}

			// ENERGY COSTS
			var energyCostsKwh = getView(sitetree.flattenedSiteTree, sitetree.currentSite, ["Meters", "Main"]);
			var eck = null;
			var ecd = null;
			if(energyCostsKwh) {
				eck = yield call(pointsservice.TrendableDataGetData, energyCostsKwh.objectID, moment(fromDate), moment(toDate), null, null, "Hourly", null, true);
				if(eck instanceof Error) {
					yield put(actions.onLoadEnergyCostsKwhFailed(eck));
				} else {
					let eckData = addEnergyCostsKwhToChart(payload.topChart, eck);
					yield put(actions.onLoadEnergyCostsKwh(eckData));
				}
			} else {
				console.warn("No meter found for site: ");
				console.warn(sitetree.currentSite);
				yield put(actions.onLoadEnergyCostsKwh([]));
			}

			if(energyCostsKwh && eck && eck.length && tariff.currentTariff && tariff.currentTariff.tariffPK) {
				ecd = yield call(pointsservice.TrendableDataGetData, energyCostsKwh.objectID, moment(fromDate), moment(toDate), tariff.currentTariff.tariffPK, tariff.currentTariffVersion, "Hourly", null, true);
				if(ecd instanceof Error) {
					yield put(actions.onLoadEnergyCostsDollarsFailed(ecd));
				} else {
					const sortedEcd = sortCosts(ecd);
					let ecdData = addEnergyCostsDollarsToChart(payload.topChart, sortedEcd);
					yield put(actions.onLoadEnergyCostsDollars(ecdData));
				}
			} else {
				console.warn("Either no meter found above, or no tariff: ");
				console.warn(tariff.currentTariff);
				yield put(actions.onLoadEnergyCostsDollars([]));
			}

			if(ecd && !(ecd instanceof Error)) {
				yield put(actions.toggleEnergyCostsDollars(payload.topChart, true));
				yield put(actions.toggleEnergyCostsKwh(payload.topChart, false));
			} else {
				if(eck && !(eck instanceof Error)) {
					yield put(actions.toggleEnergyCostsDollars(payload.topChart, false));
					yield put(actions.toggleEnergyCostsKwh(payload.topChart, true));
				} else {
					yield put(actions.toggleEnergyCostsDollars(payload.topChart, false));
					yield put(actions.toggleEnergyCostsKwh(payload.topChart, false));
				}
			}
			

			// AMBIENT TEMPERATURE
			var ambientDegCView = getView(sitetree.flattenedSiteTree, sitetree.currentSite, ["Ambient", "DegC"]);
			if(ambientDegCView) {
				var ambientDegC = yield call(pointsservice.TrendableDataGetData, ambientDegCView.objectID, moment(fromDate), moment(toDate));
				if(ambientDegC instanceof Error) {
					yield put(actions.onLoadAmbientTemperatureFailed(ambientDegC));
				} else {
					ambDegCData = addAmbientTemperatureToChart(payload.topChart, ambientDegC);
					yield put(actions.onLoadAmbientTemperature(ambDegCData));
				}
			} else {
				yield put(actions.onLoadAmbientTemperature([]));
			}

			// DIAGNOSTIC RULES
			const diagnosticRules = yield call(evidenceservice.GetDiagnosticRulesBySiteName, siteName, fromDate, toDate, ruleInstanceId);
			if(diagnosticRules instanceof Error) {
				yield put(actions.onLoadDiagnosticRulesFailed(diagnosticRules));
			} else {
				let diagRulesData = addDiagnosticRulesToChart(payload.topChart, diagnosticRules, payload.navigateFunc);
				yield put(actions.onLoadDiagnosticRules(diagRulesData));
			}

			// IMPLEMENTED CHANGES
			const implementedChanges = yield call(evidenceservice.GetImplementedChangesBySiteName, siteName, fromDate, toDate);
			if(implementedChanges instanceof Error) {
				yield put(actions.onLoadImplementedChangesFailed(implementedChanges));
			} else {
				let impChangesData = addImplementedToChart(payload.topChart, implementedChanges, payload.navigateFunc, payload.openImplementedChangeListModalFunc);
				yield put(actions.onLoadImplementedChanges(impChangesData));
			}

			// PRE-SET TESTS
			const preSetTests = yield call(evidenceservice.GetPreSetTestsBySiteName, siteName, fromDate, toDate);
			if(preSetTests instanceof Error) {
				yield put(actions.onLoadPreSetTestsFailed(preSetTests));
			} else {
				sortPSTData(preSetTests);
				let pstData = addPreSetTestsToChart(payload.topChart, preSetTests, payload.navigateFunc, evidenceComponentChart.showComments);
				let split = splitPST(pstData);
				yield put(actions.onLoadPreSetTests(pstData, split));
			}

			// LEARNED RULE CHANGES
			const learnedRuleChanges = yield call(evidenceservice.GetLearnedRuleChangesBySiteName, siteName, fromDate, toDate, ruleInstanceId);
			if(learnedRuleChanges instanceof Error) {
				yield put(actions.onLoadLearnedRuleChangesFailed(learnedRuleChanges));
			} else {
				let learnedRuleData = addLearnedRuleChangesToChart(payload.topChart, learnedRuleChanges, fromDate, toDate);
				yield put(actions.onLoadLearnedRuleChanges(learnedRuleData));
			}

			// VERIFICATION RULE FAILURES
			const verificationRuleFailures = yield call(evidenceservice.GetDailyFailedRuleCountBySiteName, siteName, fromDate, toDate, ruleInstanceId);
			if(verificationRuleFailures instanceof Error) {
				yield put(actions.onLoadVerificationRuleFailuresFailed(verificationRuleFailures));
			}
			else {
				let sortedVrf = sortVerificationRuleFailures(verificationRuleFailures);
				let vrfData = addVerificationToChart(payload.topChart, sortedVrf);
				yield put(actions.onLoadVerificationRuleFailures(vrfData));
			}

			/*
			// AUTOMATED ACTIONS
			const automatedActions = yield call(evidenceservice.GetAutomatedActionsBySiteName, siteName, fromDate, toDate, ruleInstanceId);
			if(automatedActions instanceof Error) {
				yield put(actions.onLoadAutomatedActionsFailed(automatedActions));
			} else {
				if(!(verificationRuleFailures instanceof Error)) {
					const appliedAutomatedActions = applyAutomatedActions(automatedActions, verificationRuleFailures);
					let aaData = addAutomatedActionsToChart(payload.topChart, appliedAutomatedActions);
					yield put(actions.onLoadAutomatedActions(aaData));
				} else {
					yield put(actions.onLoadAutomatedActionsFailed(verificationRuleFailures));
				}
			}
			*/
			
			const comments = yield call(evidenceservice.GetCommentsBySiteName, siteName, fromDate, toDate);
			if(comments instanceof Error) {
				yield put(actions.onLoadCommentsFailed(comments));
			} else {
				let commentData = addCommentsToChart(payload.topChart, comments);
				yield put(actions.onLoadComments(commentData));
			}

			if(payload.topChart) {
				payload.topChart.redraw();
				payload.topChart.reflow();
			}

			yield put(actions.onLoadData());
		});
	},
	
	*onToggleEnergyCostsDollars(){
		yield takeEvery(types.TOGGLE_ENERGY_COSTS_DOLLARS, function*({payload}) {
			if(payload.chart && payload.chart.series && payload.chart.series[chartIndex.energyCostsDollars]) {
				if(payload.val) {
					payload.chart.series[chartIndex.energyCostsDollars].show();
				} else {
					payload.chart.series[chartIndex.energyCostsDollars].hide();
				}
				yield put(actions.onToggleEnergyCostsDollars(payload));
			}
		});
	},
	
	*onToggleEnergyCostsKwh(){
		yield takeEvery(types.TOGGLE_ENERGY_COSTS_KWH, function*({payload}) {
			if(payload.chart && payload.chart.series && payload.chart.series[chartIndex.energyCostsKwh]) {
				if(payload.val) {
					payload.chart.series[chartIndex.energyCostsKwh].show();
				} else {
					payload.chart.series[chartIndex.energyCostsKwh].hide();
				}
				yield put(actions.onToggleEnergyCostsKwh(payload));
			}
		});
	},
	*onToggleAmbientTemperature(){
		yield takeEvery(types.TOGGLE_AMBIENT_TEMPERATURE, function*({payload}) {
			if(payload.chart && payload.chart.series && payload.chart.series[chartIndex.ambientTemperature]) {
				if(payload.val) {
					payload.chart.series[chartIndex.ambientTemperature].show();
				} else {
					payload.chart.series[chartIndex.ambientTemperature].hide();
				}
				yield put(actions.onToggleAmbientTemperature(payload));
			}
		});
	},
	*onToggleAutomatedActions(){
		yield takeEvery(types.TOGGLE_AUTOMATED_ACTIONS, function*({payload}) {
			if(payload.chart && payload.chart.series && payload.chart.series[chartIndex.automatedActions]) {
				if(payload.val) {
					payload.chart.series[chartIndex.automatedActions].show();
				} else {
					payload.chart.series[chartIndex.automatedActions].hide();
				}
				yield put(actions.onToggleAutomatedActions(payload));
			}
		});
	},
	*onToggleDiagnosticRules(){
		yield takeEvery(types.TOGGLE_DIAGNOSTIC_RULES, function*({payload}) {
			if(payload.chart && payload.chart.series && payload.chart.series[chartIndex.diagnosticRules]) {
				if(payload.val) {
					payload.chart.series[chartIndex.diagnosticRules].show();
				} else {
					payload.chart.series[chartIndex.diagnosticRules].hide();
				}
				yield put(actions.onToggleDiagnosticRules(payload));
			}
		});
	},
	*onToggleImplementedChanges(){
		yield takeEvery(types.TOGGLE_IMPLEMENTED_CHANGES, function*({payload}) {
			if(payload.chart && payload.chart.series && payload.chart.series[chartIndex.implementedChanges]) {
				if(payload.val) {
					payload.chart.series[chartIndex.implementedChanges].show();
				} else {
					payload.chart.series[chartIndex.implementedChanges].hide();
				}
			}
			yield put(actions.onToggleImplementedChanges(payload));
		});
	},
	*onToggleComments(){
		yield takeEvery(types.TOGGLE_COMMENTS, function*({payload}) {
			if(payload.chart && payload.chart.series && payload.chart.series[chartIndex.comments]) {
				if(payload.val) {
					payload.chart.series[chartIndex.comments].show();
				} else {
					payload.chart.series[chartIndex.comments].hide();
				}
			}
			yield put(actions.onToggleComments(payload));
		});
	},
	*onTogglePreSetTests(){
		yield takeEvery(types.TOGGLE_PRE_SET_TESTS, function*({payload}) {
			let {chart, val, navigateFunc} = payload;

			if(val === true) {
				// re-add
				let { preSetTests } = yield select(x => x.evidenceComponentChart);
				addPreSetTestsToChart(chart, preSetTests, navigateFunc, true);
			} else {
				// remove
				if(chart && chart.xAxis[0]) {
					chart.xAxis[0].removePlotBand("preSetTest");
				}
			}
			
			yield put(actions.onTogglePreSetTests(payload));
		});
	},
	*onToggleLearnedRuleChanges(){
		yield takeEvery(types.TOGGLE_LEARNED_RULE_CHANGES, function*({payload}) {
			if(payload.chart && payload.chart.series && payload.chart.series[chartIndex.learnedRuleChanges]) {
				if(payload.val) {
					payload.chart.series[chartIndex.learnedRuleChanges].show();
				} else {
					payload.chart.series[chartIndex.learnedRuleChanges].hide();
				}
				yield put(actions.onToggleLearnedRuleChanges(payload));
			}
		});
	},
	*onToggleVerificationRuleFailures(){
		yield takeEvery(types.TOGGLE_VERIFICATION_RULE_FAILURES, function*({payload}) {
			if(payload.chart && payload.chart.series && payload.chart.series[chartIndex.verificationRuleFailures]) {
				if(payload.val) {
					payload.chart.series[chartIndex.verificationRuleFailures].show();
				} else {
					payload.chart.series[chartIndex.verificationRuleFailures].hide();
				}
				yield put(actions.onToggleVerificationRuleFailures(payload));
			}
		});
	},
};

////////
//actions
export const actions = {
	loadData(topChart, time, navigateFunc, openImplementedChangeListModalFunc){
		return {
			type: types.TRY_LOAD_DATA,
			payload: { topChart, time, navigateFunc, openImplementedChangeListModalFunc }
		};
	},
	loadDataStopped() {
		return {
			type: types.TRY_LOAD_DATA_STOPPED,
		}
	},
	loadDataStarted() {
		return {
			type: types.LOAD_DATA_STARTED
		}
	},
	loadDataFailed() {
		return {
			type: types.LOAD_DATA_FAILED,
		};
	},
	onLoadData() {
		return {
			type: types.ON_LOAD_DATA,
		}
	},
	onLoadDataFailed(payload) {
		return {
			type: types.ON_LOAD_DATA_FAILED,
			payload
		}
	},

	mouseMovedInContainer(x, isIn, now) {
		return {
			type: types.MOUSE_MOVED_IN_CONTAINER,
			payload: {x, isIn, now}
		}
	},

	
	toggleEnergyCostsDollars(chart, val) {
		return {
			type: types.TOGGLE_ENERGY_COSTS_DOLLARS,
			payload: { chart, val }
		};
	},
	toggleEnergyCostsKwh(chart, val) {
		return {
			type: types.TOGGLE_ENERGY_COSTS_KWH,
			payload: { chart, val }
		};
	},
	toggleAmbientTemperature(chart, val) {
		return {
			type: types.TOGGLE_AMBIENT_TEMPERATURE,
			payload: { chart, val }
		};
	},
	toggleAutomatedActions(chart, val) {
		return {
			type: types.TOGGLE_AUTOMATED_ACTIONS,
			payload: { chart, val }
		};
	},
	toggleDiagnosticRules(chart, val) {
		return {
			type: types.TOGGLE_DIAGNOSTIC_RULES,
			payload: { chart, val }
		};
	},
	toggleImplementedChanges(chart, val) {
		return {
			type: types.TOGGLE_IMPLEMENTED_CHANGES,
			payload: { chart, val }
		};
	},
	togglePreSetTests(chart, val, navigateFunc) {
		return {
			type: types.TOGGLE_PRE_SET_TESTS,
			payload: { chart, val, navigateFunc }
		};
	},
	toggleLearnedRuleChanges(chart, val) {
		return {
			type: types.TOGGLE_LEARNED_RULE_CHANGES,
			payload: { chart, val }
		};
	},
	toggleVerificationRuleFailures(chart, val) {
		return {
			type: types.TOGGLE_VERIFICATION_RULE_FAILURES,
			payload: { chart, val }
		};
	},
	toggleComments(chart, val) {
		return {
			type: types.TOGGLE_COMMENTS,
			payload: { chart, val }
		}
	},
	onToggleEnergyCostsDollars(payload) {
		return {
			type: types.ON_TOGGLE_ENERGY_COSTS_DOLLARS,
			payload
		};
	},
	onToggleEnergyCostsKwh(payload) {
		return {
			type: types.ON_TOGGLE_ENERGY_COSTS_KWH,
			payload
		};
	},
	onToggleAmbientTemperature(payload) {
		return {
			type: types.ON_TOGGLE_AMBIENT_TEMPERATURE,
			payload
		};
	},
	onToggleAutomatedActions(payload) {
		return {
			type: types.ON_TOGGLE_AUTOMATED_ACTIONS,
			payload
		};
	},
	onToggleDiagnosticRules(payload) {
		return {
			type: types.ON_TOGGLE_DIAGNOSTIC_RULES,
			payload
		};
	},
	onToggleImplementedChanges(payload) {
		return {
			type: types.ON_TOGGLE_IMPLEMENTED_CHANGES,
			payload
		};
	},
	onTogglePreSetTests(payload) {
		return {
			type: types.ON_TOGGLE_PRE_SET_TESTS,
			payload
		};
	},
	onToggleLearnedRuleChanges(payload) {
		return {
			type: types.ON_TOGGLE_LEARNED_RULE_CHANGES,
			payload
		};
	},
	onToggleVerificationRuleFailures(payload) {
		return {
			type: types.ON_TOGGLE_VERIFICATION_RULE_FAILURES,
			payload
		};
	},
	onToggleComments(payload) {
		return {
			type: types.ON_TOGGLE_COMMENTS,
			payload
		}
	},
	
	onLoadEnergyCostsDollars(payload) {
		return {
			type: types.ON_LOAD_ENERGY_COSTS_DOLLARS,
			payload
		};
	},
	onLoadEnergyCostsDollarsFailed(payload) {
		return {
			type: types.ON_LOAD_ENERGY_COSTS_DOLLARS_FAILED,
			payload
		};
	},
	onLoadEnergyCostsKwh(payload) {
		return {
			type: types.ON_LOAD_ENERGY_COSTS_KWH,
			payload
		};
	},
	onLoadEnergyCostsKwhFailed(payload) {
		return {
			type: types.ON_LOAD_ENERGY_COSTS_KWH_FAILED,
			payload
		};
	},
	onLoadAmbientTemperature(payload) {
		return {
			type: types.ON_LOAD_AMBIENT_TEMPERATURE,
			payload
		};
	},
	onLoadAmbientTemperatureFailed(payload) {
		return {
			type: types.ON_LOAD_AMBIENT_TEMPERATURE_FAILED,
			payload
		};
	},
	onLoadAutomatedActions(payload) {
		return {
			type: types.ON_LOAD_AUTOMATED_ACTIONS,
			payload
		};
	},
	onLoadAutomatedActionsFailed(payload) {
		return {
			type: types.ON_LOAD_AUTOMATED_ACTIONS_FAILED,
			payload
		};
	},
	onLoadDiagnosticRules(payload) {
		return {
			type: types.ON_LOAD_DIAGNOSTIC_RULES,
			payload
		};
	},
	onLoadDiagnosticRulesFailed(payload) {
		return {
			type: types.ON_LOAD_DIAGNOSTIC_RULES_FAILED,
			payload
		};
	},
	onLoadImplementedChanges(payload) {
		return {
			type: types.ON_LOAD_IMPLEMENTED_CHANGES,
			payload
		};
	},
	onLoadImplementedChangesFailed(payload) {
		return {
			type: types.ON_LOAD_IMPLEMENTED_CHANGES_FAILED,
			payload
		};
	},
	onLoadPreSetTests(pst, psti) {
		return {
			type: types.ON_LOAD_PRE_SET_TESTS,
			payload: {pst, psti}
		};
	},
	onLoadPreSetTestsFailed(payload) {
		return {
			type: types.ON_LOAD_PRE_SET_TESTS_FAILED,
			payload
		};
	},
	onLoadLearnedRuleChanges(payload) {
		return {
			type: types.ON_LOAD_LEARNED_RULE_CHANGES,
			payload
		};
	},
	onLoadLearnedRuleChangesFailed(payload) {
		return {
			type: types.ON_LOAD_LEARNED_RULE_CHANGES_FAILED,
			payload
		};
	},
	onLoadVerificationRuleFailures(payload) {
		return {
			type: types.ON_LOAD_VERIFICATION_RULE_FAILURES,
			payload
		};
	},
	onLoadVerificationRuleFailuresFailed(payload) {
		return {
			type: types.ON_LOAD_VERIFICATION_RULE_FAILURES_FAILED,
			payload
		};
	},
	onLoadComments(payload) {
		return {
			type: types.ON_LOAD_COMMENTS,
			payload
		}
	},
	onLoadCommentsFailed(payload) {
		return {
			type: types.ON_LOAD_COMMENTS_FAILED,
			payload
		}
	},


	setCurrentLoadedTime(payload) {
		return {
			type: types.SET_CURRENT_LOADED_TIME,
			payload
		}
	},
	setCurrentLoadedSiteName(payload) {
		return {
			type: types.SET_CURRENT_LOADED_SITENAME,
			payload
		}
	},
	setCurrentLoadedTariff(payload) {
		return {
			type: types.SET_CURRENT_LOADED_TARIFF,
			payload
		}
	},
	resetCurrentLoaded() {
		return {
			type: types.RESET_CURRENT_LOADED,
		}
	},
	setRuleInstanceId(payload) {
		return {
			type: types.SET_RULE_INSTANCE_ID,
			payload
		}
	},
	setNearestValues(payload) {
		return {
			type: types.SET_NEAREST_VALUES,
			payload
		}
	},
	resetToggled() {
		return {
			type: types.RESET_TOGGLED
		}
	},

	genericAction(type, data) {
		return {
			type,
			payload: data
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/EvidenceComponents/Chart/redux.js